import Userfront from "@userfront/react";

const Logout = () => {
  Userfront.logout();
  return <div />;
};

export default Logout;
